import { registryApi, walterApi, prognoseApi, treeviaGateway } from '../clients/AxiosClients'
// import allClassificaoSitio from "../responses/classificacaoSitio/allClassificacaoSitio.json"
// import parcelasFiltradas from "../responses/classificacaoSitio/parcelasFiltradas.json"
// import modelosVariaveis from "../requests/mock/modeloVariavel.json"
// import bodyModelChosen from "./mock/ParcelasHistograma.json"

/**
 *
 * @returns Prognose dado o seu Id
 */
const getPrognosePorId = async (id) => {
	return treeviaGateway.get(`/ms-prognoses/prognose/buscar-prognose/${id}`)
}

// /**
//  *
//  * @returns dados do planejamento de uma prognose dado seu Id
//  */
// const getPlanejamentoPrognose = async id => {
//     return registryApi.get(`/Prognose/GetPrognosePlanejamento?id=${id}`);
// }

/**
 * Retorna todos Prognose cadastradas no banco de dados para popular a grid
//  */
const getAllPrognose = async () => {
	return treeviaGateway.get('/ms-prognoses/prognose/listar')
	// return allPrognose;
}

/**
 * Salva o planejamento da prognose
 */
export const salvarPlanejamento = async (body) => {
	return treeviaGateway.post(
		'/ms-prognoses/prognose/escolher-modelo-para-cada-variavel-de-interesse',
		body,
	)
}

/**
 * Cadastrar nova classificação de sítio no banco de dados
 * @param {Object} body Classificação de Sítio que será cadastrada
//  */
// const createClassificacaoSitio = async (body) => {
//     return classificacaoSitioApi.post('/Registry/', body)
// }

/**
 * Atualiza Classificação de Sítio no banco de dados
 * @param {Object} body Classificação de Sítio que será atualizada
//  */
// const updateClassificacaoSitio = async (body) => {
//     return registryApi.put('/ClassificacaoSitio/', body)
// }

/**
 * Lista dos ids de Classificação de Sítio que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Classificação de Sítio
 */
const deletePrognoseByIdList = async (data) => {
	return treeviaGateway.delete('/ms-prognoses/prognose/excluir', { data })
}

/**
 *
 * @param {Object} filtros Várias listas de filtros
 *
 * Filtros inicialmente suportados:
 *
 * • Lista de Estratos
 * • Lista de Data de Plantio
 * • Lista de Idade do Plantio
 * • Lista de Material Genético
 * • Lista de Espécie
 * • Lista de Data de Medição
 * • Lista de Fazenda
 * • Lista de Espaçamento
 * • Lista de Variável Customizadas
 * • Tipo de Serviço (IFI, IFC, IPC)
 */

/**
 * Retorna os dados para tela vincula prognose com paginação
 * @param {number} PagNumber - Número da página
 * @param {number} PagSize - Tamanho da página
 * @param {string} FilteringWord - Palavra chave busca
 */
const getAllAplicaPrognose = async (PagNumber, PagSize, FilteringWord) => {
	return treeviaGateway.post(
		'/ms-prognoses/vinculaprognose/dados-para-tela-vincula-prognose',
		{ PagNumber, PagSize, FilteringWord },
		{ timeout: 600000 },
	)
}

const getDropdownExportacaoProjecoes = async () => {
	return treeviaGateway.get('/ms-prognoses/exportacaodeprojecoes/dropdown-exportacao-projecoes')
}

const exportarANivelDeEstratoEInventarioFlorestal = async (idsPrognoseAplicada) => {
	return treeviaGateway.post(
		'/ms-prognoses/exportacaodeprojecoes/exportar-a-nivel-de-estrato-e-inventario-florestal',
		idsPrognoseAplicada,
	)
}

const exportarANivelDePlantio = async (idsPrognosePlantio) => {
	return treeviaGateway.post(
		'/ms-prognoses/exportacaodeprojecoes/exportar-a-nivel-de-plantio',
		idsPrognosePlantio,
	)
}

const especiesDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/especies')
}

const materialGeneticoDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/material-genetico')
}

const idadePlantioDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/idade-plantio')
}

const fazendasDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/fazendas')
}

const espacamentosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/espacamentos')
}

const estratosDropdown = async () => {
	return registryApi.get('v1/filtrocategoriaprognose/estratos')
}

const getFiltrosDropdown = async () => {
	//const { data: dataPlantio } = await dataPlantioDropdown()
	const { data: especies } = await especiesDropdown()
	const { data: materialGenetico } = await materialGeneticoDropdown()
	const { data: idadePlantio } = await idadePlantioDropdown()
	const { data: fazendas } = await fazendasDropdown()
	const { data: espacamentos } = await espacamentosDropdown()
	const { data: estratos } = await estratosDropdown()
	//const { data: datasMedicao } = await dataMedicaoDropdown();

	return {
		//datasPlantio: dataPlantio.result.map((d) => {
		//  return { value: d.id, label: d.descricao }
		//}),
		especies: especies.result,
		materiaisGeneticos: materialGenetico.result.map((d) => {
			return { value: d.id, label: d.descricao }
		}),
		idadesPlantio: idadePlantio.result.map((d) => {
			return { value: d.id, label: d.idade }
		}),
		fazendas: fazendas.result,
		espacamentos: espacamentos.result.map((d) => {
			return { value: d.id, label: d.descricao }
		}),
		estratos: estratos.result,
		//datasMedicao : datasMedicao.result
	}
}

const filterParcelasPrognose = async (params) => {
	const obterDataHoje = () => {
		const hoje = new Date()
		const ano = hoje.getFullYear()
		const mes = ('0' + (hoje.getMonth() + 1)).slice(-2) // +1 porque getMonth() retorna 0-11
		const dia = ('0' + hoje.getDate()).slice(-2)
		return ano + '-' + mes + '-' + dia
	}

	//tratamento de Data de Plantio para a busca da prognose
	if (params.datasPlantio[0] || params.datasPlantio[1]) {
		params.datasPlantio[0] = params.datasPlantio[0] ? params.datasPlantio[0] : '1500-01-01'
		params.datasPlantio[1] = params.datasPlantio[1] ? params.datasPlantio[1] : obterDataHoje()
	} else {
		params.datasPlantio = []
	}
	//tratamento de Data de Medição para a busca da prognose
	if (params.datasMedicao[0] || params.datasMedicao[1]) {
		params.datasMedicao[0] = params.datasMedicao[0] ? params.datasMedicao[0] : '1500-01-01'
		params.datasMedicao[1] = params.datasMedicao[1] ? params.datasMedicao[1] : obterDataHoje()
	} else {
		params.datasMedicao = []
	}

	return registryApi.post('v1/filtrocategoriaprognose/filtro-para-prognose', params)
}

// const sendProcessamento = async () => {
//   return modelosVariaveis
//   // return walterApi.post("/SiteClassificationModelAdjustment/SiteClassificationModels", { parcelas: body })
//   // return classificacaoSitioApi.post("/classificacaodesitiomodelos/gerar-modelos", { amostras: body })
// }

const chooseModel = async (body) => {
	// body = bodyModelChosen;
	return walterApi.post('/SiteClassificationModelAdjustment/SiteClassificationDefaultMethods', body)
}

const gerarModeloSemSitio = async (body) => {
	// body = bodyModelChosen;
	return prognoseApi.post('/prognosesmodelos/gerar-modelos-sem-sitio', body)
}

const gerarModeloComSitio = async (body) => {
	// body = bodyModelChosen;
	return prognoseApi.post('/prognosesmodelos/gerar-modelos', body)
}

const updatePrognose = async (body) => {
	return treeviaGateway.put('/ms-prognoses/prognose/editar-prognose', body)
}

export {
	//   filtraParcelas,
	getAllAplicaPrognose,
	getDropdownExportacaoProjecoes,
	exportarANivelDeEstratoEInventarioFlorestal,
	exportarANivelDePlantio,
	getFiltrosDropdown,
	filterParcelasPrognose,
	//   sendProcessamento,
	chooseModel,
	gerarModeloSemSitio,
	getPrognosePorId,
	gerarModeloComSitio,
	getAllPrognose,
	deletePrognoseByIdList,
	updatePrognose,
}
